import "../../pages/new/new.scss"

import { Link } from "react-router-dom";
import React, { useState,useEffect } from 'react';
import { useNavigate,useParams } from 'react-router-dom';
import { Container, TextField, Button, Box } from '@mui/material';
import { getStudentThesis } from '../../services/thesisService';
import { getAllThesis, getFeedbackById } from '../../services/thesisService';
import axiosInstance from '../../api/axios';
import { getAllStudentFeedbacks} from '../../services/feedbackService';
import { Tabs, Tab } from '@mui/material';
import {StudentInfo} from './StudentInfo';
import { DataGrid } from '@mui/x-data-grid';
import TextBox from "./TextBox";
export const ThesisMentor = ({ studentId: propStudentId,viewMode }) => {
  
    const examinerId = parseInt(localStorage.getItem('examinerId'), 10);
    const { studentId: paramStudentId } = useParams();
    const studentId = propStudentId || paramStudentId;
    const [feedbacks, setFeedbacks] = useState([]);
    const [monthlyFeedbacks, setMonthlyFeedbacks] = useState([]);
    const [examinerFeedbacks, setExaminerFeedbacks] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [thesisData, setThesisData] = useState({
        id:'',
        thesis_title: '',
        student_name:'',
        mentor1_name: '',
        mentor2_name: '',
       
    });
    const handleLinkClick = (url) => {
      window.open(url, '_blank', 'noopener,noreferrer');
    };
    const columns = React.useMemo(
        () => [
            { field: 'examiner_name', headerName: 'Examiner/Reviewer Name', width: 150 },
            {
              field: 'role',
              headerName: 'Role',
              width: 120,
              renderCell: (params) => {
                const isExaminer = params.row?.is_examiner || '';
                const isReviewer = params.row?.is_reviewer || '';
                if (isExaminer)
                  return 'Examiner'
                return 'Reviewer';
              },
            },
            {
              field: 'combined_report',
              headerName: 'Report Type',
              width: 150,
              renderCell: (params) => {
                const reportType = params.row?.report_type || '';
                const reportMonth = params.row?.report_month || '';
                if (reportType == 'ProjectProposal')
                  return 'Project Proposal'
                return `${reportType}  ${reportMonth}`;
              },
            },
            {
              field: 'folder_link', headerName: 'Folder Link', width: 200, renderCell: (params) => (
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <Link
                    href={params.value}
                    onClick={(event) => handleLinkClick(params.value, event)}
                    style={{
                      color: 'blue',
                      textDecoration: 'underline',
                      marginRight: '10px',
                      cursor: 'pointer',
                    }}
                  >
                    {params.value}
                  </Link>
                </div>
              ),
            },
            { field: 'overall_feedback', headerName: 'Feedback', width: 300 }
        ],
        []
    );
    const monthly = async () => {setMonthlyFeedbacks(feedbacks.filter(feedbacks => feedbacks.type == "Monthly"))}
    const examiner = async () => {setExaminerFeedbacks(feedbacks.filter(feedbacks => feedbacks.type !== "Monthly" ))}

    const fetchFeedbacks = async () => {
        try {
            const data = await getAllStudentFeedbacks(studentId,false);
           // console.log(data);
            setFeedbacks(data.data);
        } catch (err) {
            setError(err);
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        const fetchThesis = async (studentId) => {
            try {
                const data = await getStudentThesis(studentId);
               // console.log(data.data[0]);
                setThesisData(data.data[0]);
              //  console.log(thesisData);
            } catch (err) {
    
            }
        };
        fetchThesis(studentId);
        fetchFeedbacks();
        monthly();
        examiner();
    }, []);
    useEffect(() => {

        monthly();
        examiner();
    }, [feedbacks]);
    const [activeTab, setActiveTab] = useState(0);

    const handleTabChange = (event, newValue) => {
        setActiveTab(newValue);
    };
    const handleButtonClick = async (id,share_to_student) => {
      try {
        const response = await getFeedbackById(id);
        const feedback=response.data;
        feedback.shareToStudent=!share_to_student;
        const response1 = await axiosInstance.put('/feedbacks', feedback, { showToastOnResponse: true });
        fetchFeedbacks();
        monthly();
        examiner();
        
      } catch (error) {
        console.error('Error:', error);
      }
    };
    const actionColumn = [{ field: "action", headerName:"Action", width:200,
        renderCell:(params)=>{
            const { id,share_to_student } = params.row;
            return(
                <div className="cellAction">
                    <div className="viewButton"><Link to={{pathname: `/feedbacks/view-feedback/${studentId}/${id}`, state: { studentId: 'studentId' },}} style={{textDecoration:"none"}}>View</Link></div>     
                    {!examinerId && <div className="viewButton"><button onClick={() => handleButtonClick(id,share_to_student)}>
      {(share_to_student === null || !share_to_student) ? 'Share' : 'UnShare'}
    </button></div>  }                                
                </div>
            );
        }
    }]
    return (
        <div className="bottom">
        <div className="left"></div>
        <div className="right">
        <form>
        <div className="formInput">
              <label>Student Name </label>
              <input type="text" 
              name="student_name"
              value={thesisData && thesisData.student_name?thesisData.student_name:""}
              readOnly={true}
              />
              
            </div>
            <div className="formInput">
              <label>Enrollment Number </label>
              <input type="text" 
              name="enrollment_number"
              value={thesisData && thesisData.enrollment_number?thesisData.enrollment_number:""}
              readOnly={true}
              />
              
            </div>
            <div className="formInput">
              <label>Thesis Title </label>
              <TextBox type="text" 
              name="thesis_title"
              value={thesisData && thesisData.thesis_title?thesisData.thesis_title:""}
              readOnly={true}
              />
              
            </div>

            <div className="formInput">
              <label>Mentor1 Name </label>
              <input type="text" 
              name="mentor1_name"
              value={thesisData && thesisData.mentor1_name?thesisData.mentor1_name:""}
              readOnly={true}
              />
              
            </div>

            <div className="formInput">
              <label>Mentor2 Name </label>
              <input type="text" 
              name="mentor2_name"
              value={thesisData && thesisData.mentor2_name?thesisData.mentor2_name:""}
              readOnly={true}
              />
              
            </div>
            
          </form>
          {thesisData && thesisData.thesis_title &&

          <Tabs value={activeTab} onChange={handleTabChange}>
          <Tab label="Monthly Feedbacks" />
          <Tab label="Examiner Feedbacks" />
      </Tabs>}
      {thesisData && thesisData.thesis_title && activeTab === 0 && <div className="datatable" >
        <DataGrid 
      rows={monthlyFeedbacks}
      columns={columns.concat(actionColumn)}
      initialState={{
        pagination: {
          paginationModel: { page: 0, pageSize: 10 },
        },
      }}
      pageSizeOptions={[5, 10]}
      //checkboxSelection
    /></div>}
      {thesisData && thesisData.thesis_title && activeTab === 1   && <div className="datatable"  >
        <DataGrid 
      rows={examinerFeedbacks}
      columns={columns.concat(actionColumn)}
      initialState={{
        pagination: {
          paginationModel: { page: 0, pageSize: 10 },
        },
      }}
      pageSizeOptions={[5, 10]}
      //checkboxSelection
    /></div>}
          </div>
          </div>
    );
};